import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { Button, Divider, Typography, Icon, Grid, ListItemText, Avatar } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Header from '../common/Header';
import CartMenuList from './CartMenuList';
import Bottom from './Bottom';
import Progress from '../common/Progress';
import ReceiveMethodButtonGroup from './ReceiveMethodButtonGroup';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import { withRouter } from 'react-router';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class Cart extends Component {
  constructor(props) {
    super(props);
    SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
    this.state = {
      recommendedMenus: [],
    };
  }

  /** 추천메뉴 리스트 조회 */
  getRecommendedMenus = () => {
    const { menuStore } = this.props;
    const recommendedMenus = [];
    if (menuStore.storeData.isRecommendedMenuUsed && menuStore.storeData.recommendedMenus) {
      const itemCodes = menuStore.storeData.recommendedMenus.split(',');
      itemCodes.forEach(itemCode => {
        const findMenu = menuStore.storeData.menus.find(menu => menu.itemCode === itemCode);
        if (findMenu) recommendedMenus.push(findMenu);
      });
    }
    return recommendedMenus;
  };

  async componentDidMount() {
    const { commonStore, match } = this.props;
    await commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);

    this.setState(() => ({ recommendedMenus: this.getRecommendedMenus() }));
  }

  handleClickAddMore = () => {
    const { commonStore, history, location } = this.props;
    history.push(`/${commonStore.companyId.toLowerCase()}/${commonStore.storeCode}${location.search}`);
  };

  // 메뉴 클릭시 상세로 이동
  handleMenuItemClick = menu => {
    const { commonStore, history, location } = this.props;
    history.push(`/${commonStore.companyId}/${commonStore.storeCode}/menus/${menu.itemCode}${location.search}`);
  };

  menuPriceComponent = menu => {
    const { menuStore } = this.props;

    const menuPriceInfo = menuStore.getMenuPriceInfo(menu);

    if (menuPriceInfo.discountAmount === 0) {
      return (
        <div style={{ textAlign: 'right' }}>
          <CurrencyDisplay amount={menuPriceInfo.discountedAmount} type="emphasis" />
        </div>
      );
    } else {
      return (
        <div className="price-discount-info-vertical">
          <CurrencyDisplay amount={menuPriceInfo.price} type="disabled" />
          <span className="emphasis" style={{ fontSize: '16px' }}>
            {menuPriceInfo.discountPercentage}%
          </span>
          <CurrencyDisplay amount={menuPriceInfo.discountedAmount} type="emphasis" />
        </div>
      );
    }
  };

  render() {
    const { menuStore, cartStore, t } = this.props;
    if (!menuStore.storeData) return <Progress />;
    return (
      <React.Fragment>
        {/* 헤더 */}
        <Header iconType="CART_CLEAR" title={t('cart.title.main')} />

        <div className="contents-full">
          {/* 매장이름 */}
          <div style={{ height: '60px', padding: '10px 16px', backgroundColor: '#E7E7E7' }}>
            <Icon edge="start" style={{ color: '#F50057', marginRight: '5px' }}>
              <LocationOnIcon />
            </Icon>
            <Typography component="span" color="textPrimary" variant="h6" style={{ fontWeight: 'bold' }}>
              {menuStore.storeData.storeName}
            </Typography>
          </div>
          <Divider variant={'fullWidth'} />

          <div className="cart-contents">
            {/* 수령 방법 선택 버튼 */}
            <ReceiveMethodButtonGroup />

            {/* 장바구니 리스트 */}
            {cartStore.cartData.menus.length > 0 ? (
              <CartMenuList />
            ) : (
              <Typography align="center" style={{ paddingTop: '20px' }}>
                {t('cart.text.empty')}
              </Typography>
            )}

            {/* 더 담으러 가기 버튼 */}
            <Grid container alignContent={'center'} style={{ paddingTop: '8px', paddingBottom: '16px' }}>
              <Button fullWidth onClick={this.handleClickAddMore} color={'secondary'}>
                <span style={{ fontSize: '13pt' }}>+ {t('cart.button.addMore')}</span>
              </Button>
            </Grid>

            {this.state.recommendedMenus.length > 0 && (
              <div className="recommended-wrapper">
                <div className="recommended-title">{t('menu.title.recommended')}</div>
                <Swiper
                  slidesPerView={'auto'}
                  spaceBetween={20}
                  scrollbar={{ draggable: true }} // 스크롤바 추가
                >
                  {this.state.recommendedMenus.map(menu => (
                    <SwiperSlide
                      key={menu.itemCode}
                      className={menu.isSoldOut ? 'sold-out' : ''}
                      onClick={() => this.handleMenuItemClick(menu)}
                    >
                      <div className="recommended-image">
                        <Avatar
                          src={menuStore.getImageUrl(menu.itemStoreCode, menu.pictureFileName1, menu.pictureFileName2)}
                          sx={{ width: '130px', height: '130px' }}
                        ></Avatar>
                      </div>
                      <ListItemText
                        primary={
                          <Typography
                            component="span"
                            variant="subtitle1"
                            color="textPrimary"
                            className="recommended-title"
                            style={{ fontWeight: 'bold' }}
                          >
                            {menu.name}
                            {menu.isSoldOut ? ` (${t('menu.label.soldout')})` : ''}
                          </Typography>
                        }
                        secondary={this.menuPriceComponent(menu)}
                        secondaryTypographyProps={{ component: 'div' }}
                        className="recommended-info"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>
        </div>

        {/* 주문하기 버튼 */}
        <Bottom />
      </React.Fragment>
    );
  }
}

export default withTranslation()(withRouter(Cart));
